import axios from 'ps-components/lib/apiClient';
import { useQuery } from 'react-query';
import { QueryKeys } from '../../constants/query-keys';

export type RulesBasedPricingRule = {
  id: string
  name: string
  lowerLimitEE: number
  lowerLimitCO: number
  lastModified: Date
  lastModifiedBy: {
    firstName: string
    lastName: string
  }
}

export const useRulesBasedPricingList = () => {
  const getRulesBasedPricingList = async (): Promise<RulesBasedPricingRule[]> => {
    const response = await axios.apiGet(`/api/rules/rules-list/ruleList`, { params: { notEmpty: true } })
    return response.data
  }

  const query = useQuery([QueryKeys.RULES_BASED_PRICING_LIST, { notEmpty: true }], getRulesBasedPricingList, { staleTime: Infinity })

  return query
}
